module.exports = __webpack_public_path__ + "img/Eventos_notificacion_rechazo.0148af1f.svg";